import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getPuscharseSaleEntitys from '../../services/dossier/get/getPuscharseSaleEntitys'
import commonActions from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchCombosSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'

export function * fetchPuscharseSaleEntitys ({ organizedUnitId }) {
  try {
    yield put(commonActions.showLoader())
    const auth = yield select(getAuth)
    const puscharseSaleEntitys = yield call(getPuscharseSaleEntitys, auth.token, organizedUnitId)
    yield put(fetchCombosSuccess({ puscharseSaleEntitys }))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(commonActions.hideLoader())
  }
}

export function * watchFetchPuscharseSaleEntitys () {
  yield takeLatest(combosActionTypes.FETCH_PUSCHARSE_SALE_ENTITYS, fetchPuscharseSaleEntitys)
}
